import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import * as WebActions from './web.actions';
import * as WebSelectors from './web.selector';
import type { BookingStorePayload, Extras } from '../../models/booking';
import type { FiltersPaylod } from '../../models/car-filters';
import type { LocationDetail } from '../../models/location-detail';

@Injectable({ providedIn: 'root' })
export class WebFacade {
  private readonly store = inject(Store);

  // car detail
  carDetail$: Observable<BookingStorePayload> = this.store.select(WebSelectors.SELECT_CAR_DETAIL);

  setCarDetail(carDetail: BookingStorePayload): void {
    this.store.dispatch(WebActions.setCarDetail({ carDetail }));
  }

  // location detail
  locationDetail$: Observable<LocationDetail> = this.store.select(
    WebSelectors.SELECT_LOCATION_DETAIL
  );

  setLocationDetail(locationDetail: LocationDetail): void {
    this.store.dispatch(WebActions.setLocationDetail({ locationDetail }));
  }

  // autocomplete locations
  locationAutoCompleteList$ = this.store.select(WebSelectors.SELECT_LOCATION_AUTO_COMPLETE_LIST);
  isSearchingLocation$ = this.store.select(WebSelectors.SELECT_IS_SEARCHING_LOCATION);

  getLocationAutoComplete(searchValue: string): void {
    this.store.dispatch(WebActions.loadLocationAutoComplete({ searchValue }));
  }

  // filters
  filters$ = this.store.select(WebSelectors.SELECT_FILTERS);
  filterNames$ = this.store.select(WebSelectors.SELECT_FILTER_NAMES);
  filterMakes$ = this.store.select(WebSelectors.SELECT_FILTER_MAKES);
  filterTransmission$ = this.store.select(WebSelectors.SELECT_FILTER_TRANSMISSION);
  filterSeats$ = this.store.select(WebSelectors.SELECT_FILTER_SEATS);
  filterTypes$ = this.store.select(WebSelectors.SELECT_FILTER_TYPES);

  loadFilters(payload: FiltersPaylod): void {
    this.store.dispatch(WebActions.loadFilters({ payload }));
  }

  // extras
  extras$: Observable<Extras[]> = this.store.select(WebSelectors.SELECT_EXTRAS);
  extrasLoading$: Observable<boolean> = this.store.select(WebSelectors.SELECT_EXTRAS_LOADING);
  additionalDriverPrice$ = this.store.select(WebSelectors.SELECT_ADDITIONAL_DRIVER_PRICE);
  unlimitedKMAllowancePrice$ = this.store.select(WebSelectors.SELECT_UNLIMITED_KM_ALLOWANCE_PRICE);

  loadExtras(): void {
    this.store.dispatch(WebActions.loadExtras());
  }

  // clear state
  clearWebState(): void {
    this.store.dispatch(WebActions.clearWebState());
  }
}
